import "featherlight/release/featherlight.min.css";
import "featherlight/release/featherlight.gallery.min.css";

function initMap( $el ) {
    var $markers = $el.find('.marker');
    var mapArgs = {
        zoom        :  $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        styles      : getStyle(),
        draggable   : false,
        zoomControl : false,
        scrollwheel : false,
        disableDoubleClickZoom: true
    };
    var map = new google.maps.Map( $el[0], mapArgs );
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });
    centerMap( map );
    return map;
}
function initMapBig( $el ) {
    var $markers = $el.find('.marker');
    var mapArgs = {
        zoom        :  $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
    };
    var map = new google.maps.Map( $el[0], mapArgs );
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map, false );
    });
    centerMap( map );
    return map;
}
function initMarker( $marker, map, custom = true ) {
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    if(custom) {
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            icon: '/app/themes/landrins-theme/assets/images/marker.png',
        });
    } else {
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
        });
    }

    map.markers.push( marker );

    if( $marker.html() ){

        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}
function centerMap( map ) {
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    } else{
        map.fitBounds( bounds );
    }
}

$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });

});

if(typeof $('.show-big').featherlight !== "undefined") {
    $('.show-big').featherlight('#maplightbox', {
        afterOpen: function(){
            $('.featherlight .featherlight-inner .acf-map-big').each(function(){
                var map = initMapBig( $(this) );
            });
        },
    });
}
function getStyle() {
    return [ { "elementType": "geometry", "stylers": [ { "color": "#333333" } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "elementType": "labels.text.fill", "stylers": [ { "color": "#ffffff" }, { "visibility": "simplified" } ] }, { "featureType": "administrative", "elementType": "geometry", "stylers": [ { "color": "#757575" } ] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [ { "color": "#e3e3e3" } ] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.business", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.business", "elementType": "geometry.stroke", "stylers": [ { "color": "#c39d9d" }, { "visibility": "off" } ] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [ { "color": "#3b3b3b" } ] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "color": "#b2b2b2" }, { "visibility": "on" } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#595959" } ] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [ { "color": "#757575" } ] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#111111" }, { "visibility": "off" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#3d3d3d" } ] } ];
}
